<template>
  <div class="container">
    <div class="content-box" v-if="parceiro">
      <div class="element-wrapper pb-0">
        <div class="element-header">
          <div class="row">
            <div class="col-md-8 mr-auto">
              <h3 class>Nova Oferta para {{parceiro.nome}}</h3>
            </div>
            <div class="col-auto">
              <b-button @click="voltar">Voltar</b-button>
            </div>
          </div>
        </div>
        <div class="element-box">
          <form @submit.prevent="salvar">
            <div class="form-row">
              <div class="col-md-12 form-group" :class="{'has-danger': errors.has('tipo')}">
                <label for="tipo">Tipo de Oferta</label>
                <multiselect
                    id="tipo"
                    ref="tipo"
                    name="tipo"
                    v-model="oferta.event"
                    v-validate="'required'"
                    label="name"
                    value="id"
                    track-by="id"
                    placeholder="Selecione um tipo"
                    :showLabels="false"
                    :options="tipos"
                ></multiselect>
                <div
                    v-if="errors.has('tipo')"
                    class="help-block form-text text-muted form-control-feedback"
                >{{errors.first('tipo')}}</div>
              </div>
            </div>
            <div class="form-row" v-if="oferta.event && oferta.event.id === 'online'">
              <div class="col-md-12 form-group" :class="{'has-danger': errors.has('onlineLink')}">
                <label for="onlineLink">Link</label>
                <input type="url" id="onlineLink" name="onlineLink" v-validate="'required'"
                       v-model="oferta.eventData.online_link" class="form-control">
                <div
                    v-if="errors.has('onlineLink')"
                    class="help-block form-text text-muted form-control-feedback"
                >{{errors.first('onlineLink')}}</div>
              </div>
            </div>
            <div class="form-row" v-if="oferta.event && oferta.event.id === 'uniqueCode'">
              <div class="col-md-3 form-group" :class="{'has-danger': errors.has('limite')}">
                <label for="limite">Limite</label>
                <input type="number" id="limite" name="limite" v-validate="'required'"
                       v-model="oferta.eventData.limit" class="form-control">
                <div
                    v-if="errors.has('limite')"
                    class="help-block form-text text-muted form-control-feedback"
                >{{errors.first('limite')}}</div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6">
                <div class="row">
                  <div class="col-md-4 form-group">
                    <label for="symbol">Descontos</label>
                    <multiselect
                        id="symbol"
                        name="symbol"
                        v-model="oferta.symbol"
                        v-validate="'required'"
                        label="name"
                        value="id"
                        track-by="id"
                        placeholder="Selecione um tipo"
                        :showLabels="false"
                        :options="simbolos"
                    ></multiselect>
                  </div>
                  <div v-if="exibeValor" class="col-md-3 form-row" :class="{'has-danger': errors.has('valor')}">
                    <label>Valor</label>
                    <money v-if="oferta.symbol && oferta.symbol.id === 'R$'"
                        required
                        v-model="oferta.value"
                        name="valor"
                        class="form-control"
                        id="valor"
                    />
                    <input type="number" v-else
                           required
                           v-model="oferta.value"
                           name="valorPct"
                           class="form-control"
                           id="valorPct"
                    />
                    <div
                        v-if="errors.has('valor')"
                        class="help-block form-text text-muted form-control-feedback"
                    >{{errors.first('valor')}}</div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="col-md-12 form-group" :class="{'has-danger': errors.has('nome')}">
                    <label for="nome">Nome</label>
                    <input id="nome" name="nome" v-validate="'required'"
                           v-model="oferta.nome" class="form-control">
                    <div
                        v-if="errors.has('nome')"
                        class="help-block form-text text-muted form-control-feedback"
                    >{{errors.first('nome')}}</div>
                  </div>
                </div>
                <div class="form-row">
                  <div class="col-md-12 form-group" :class="{'has-danger': errors.has('titulo')}">
                    <label for="titulo">Titulo</label>
                    <input id="titulo" name="titulo" v-validate="'required'"
                           v-model="oferta.titulo" class="form-control">
                    <div
                        v-if="errors.has('titulo')"
                        class="help-block form-text text-muted form-control-feedback"
                    >{{errors.first('titulo')}}</div>
                  </div>
                </div>

                <div class="form-row">
                  <div class="col-md-4 form-group" :class="{'has-danger': errors.has('dataInicio')}">
                    <label for="dataInicio">Data Inicial</label>
                    <datepicker
                        id="dataInicio" name="dataInicio"
                        calendar-button-icon="fa fa-calendar-alt"
                        clear-button
                        bootstrap-styling
                        calendar-button
                        v-validate="{ required: isRequiredDate }"
                        v-model="oferta.start_date"></datepicker>
                    <div
                        v-if="errors.has('dataInicio')"
                        class="help-block form-text text-muted form-control-feedback"
                    >{{errors.first('dataInicio')}}</div>
                  </div>
                  <div class="col-md-4 form-group" :class="{'has-danger': errors.has('dataFinal')}">
                    <label for="dataFinal">Data Final</label>
                    <datepicker
                        id="dataFinal" name="dataFinal"
                        calendar-button-icon="fa fa-calendar-alt"
                        clear-button
                        bootstrap-styling
                        calendar-button
                        v-validate="{ required: isRequiredDate }"
                        v-model="oferta.end_date"></datepicker>
                    <div
                        v-if="errors.has('dataFinal')"
                        class="help-block form-text text-muted form-control-feedback"
                    >{{errors.first('dataFinal')}}</div>
                  </div>
                </div>

                <div class="form-row">
                  <div class="col-md-12 form-group">
                    <label for="importante">Informações Importantes</label>
                    <textarea class="form-control" name="importante" id="importante"
                              v-validate="'required'" v-model="oferta.important"
                              cols="30" rows="10"></textarea>
                  </div>
                </div>
              </div>
              <div class="col-md-6">
                <div class="row mb-4">
                  <div class="col-md-12">
                    <label for="tipo">Nº de Passos</label>
                    <multiselect
                        id="nPassos"
                        name="nPassos"
                        v-model="qtdPasso"
                        v-validate="'required'"
                        placeholder="Selecione a quantidade de passos"
                        :showLabels="false"
                        :options="passos"
                    ></multiselect>
                    <div
                        v-if="errors.has('nPassos')"
                        class="help-block form-text text-muted form-control-feedback"
                    >{{errors.first('nPassos')}}</div>
                  </div>
                </div>
                <div class="form-row" v-for="(p, i) in qtdPasso" :key="i">
                  <div class="col" :class="{'has-danger': errors.has(`passo${p}`)}">
                    <label :for="`passo${p}`">Passo {{p}}</label>
                    <textarea class="form-control" :name="`passo${p}`" :id="`passo${p}`"
                              v-validate="'required'" v-model="oferta.howtos[i]"
                              cols="30" rows="4"></textarea>
                    <div
                        v-if="errors.has(`passo${p}`)"
                        class="help-block form-text text-muted form-control-feedback"
                    >{{errors.first(`passo${p}`)}}</div>
                  </div>
                </div>

                <div class="row mt-2" v-if="oferta.event && oferta.event.id === 'online'">
                  <div class="col-md-3">
                    <label>Cupom</label>
                    <input v-model="oferta.voucher" class="form-control">
                  </div>
                </div>
              </div>
            </div>


            <div class="row">
              <div class="col center-block">
                <button class="btn btn-primary" type="submit">Salvar</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';
import datepicker from 'vuejs-datepicker';
import axios from "axios";

export default {
  name: "OfertaForm",
  components: {
    Multiselect,
    datepicker
  },
  async created() {
    const {parceiro} = this.$route.query;
    this.parceiro = await axios.get(`/api/parceiro/${parceiro}`).then(response => response.data);
    await this.loadOferta();
  },
  computed: {
    exibeValor() {
      if (this.oferta.symbol) {
        return ['2x1', 'GRÁTIS'].indexOf(this.oferta.symbol.id) < 0;
      }
      return true;
    },
    isRequiredDate() {
      return this.oferta.event && this.oferta.event.id !== 'online'
    }
  },
  watch: {
    'oferta.symbol': function (newSymbol, oldSymbol) {
      if (newSymbol && oldSymbol) {
        this.oferta.value = null;
      }
    }
  },
  data: () => ({
    parceiro: null,
    qtdPasso: 3,
    oferta: {
      event: null,
      nome: null,
      titulo: null,
      important: null,
      symbol: null,
      value: null,
      eventData: {},
      start_date: null,
      end_data: null,
      howtos: []
    },
    simbolos: [
      {
        id: 'R$',
        name: 'R$'
      },
      {
        id: '%',
        name: '%'
      },
      {
        id: '2x1',
        name: '2x1'
      },
      {
        id: 'GRÁTIS',
        name: 'Grátis'
      }
    ],
    tipos: [
      {
        id: 'info',
        name: 'Info'
      },
      {
        id: 'voucher',
        name: 'Voucher'
      },
      {
        id: 'online',
        name: 'Online'
      },
      {
        id: 'uniqueCode',
        name: 'Código Único'
      },
    ],
    passos: [2, 3]
  }),
  methods: {
    voltar() {
      window.history.back();
    },
    salvar() {
      this.$store.dispatch('setLoading', true);
      this.$validator.validateAll().then(async (result) => {
        if (result) {
          this.oferta.parceiro = this.parceiro;
          this.oferta.event = this.oferta.event.id;
          await axios.post(`/api/parceiro/${this.parceiro._id}/ofertas`, this.oferta);

          this.$store.dispatch('setLoading', false);
          this.$router.push({name: 'OfertaList', query: {parceiro: this.parceiro._id}})
        }
        this.$store.dispatch('setLoading', false);
      });
    },
    async loadOferta() {
      const id = this.$route.query['id'];
      if (id) {
        this.$store.dispatch('setLoading', true);
        this.oferta = await axios.get(`/api/oferta/${id}`).then(response => response.data);
        this.oferta.event = this.tipos.find(t => t.id === this.oferta.event);
        this.qtdPasso = this.oferta.howtos.length
        if (!this.oferta.eventData){
          this.oferta.eventData = {}

        }
        this.$store.dispatch('setLoading', false);
      }
    }
  }
}
</script>

<style scoped>

</style>
